//@ts-nocheck
import React from 'react';
import { DashboardControl, ResourceManager } from 'devexpress-dashboard';
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css'
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css'
import '@devexpress/analytics-core/dist/css/dx-querybuilder.css'
import 'devexpress-dashboard/dist/css/dx-dashboard.light.css'
import { SpeedDialAction } from 'devextreme-react/speed-dial-action';
import configuration from "../../../configuration";
import {getUserToken} from "fulogics-ui-core";

class DashboardComponent extends React.Component {
    constructor(props) {
        super(props);
        ResourceManager.embedBundledResources();
        //
        this.changeMode = this.changeMode.bind(this);
    }

    componentDidMount() {
        let tokenResponse = getUserToken();
        this.dashboardControl = new DashboardControl(this.refs.dashboardcontainer, {
            // Specifies the URL where the Web Dashboard's server side is hosted.
            endpoint: "https://demos.devexpress.com/services/dashboard/api",//configuration.DASHBOARD.ApiUrl,
            workingMode: "Viewer",
            ajaxRemoteService: {
                headers: {
                    'Authorization': `Bearer ${tokenResponse.access_token}`
                }
            }
        });
        this.dashboardControl.render();
    }
    
    componentWillUnmount() {
        this.dashboardControl.dispose();
    }

    changeMode() {
        var workingMode = this.dashboardControl.isDesignMode();
        if (workingMode === true) {
            this.dashboardControl.switchToViewer();
        }
        else {
            this.dashboardControl.switchToDesigner();
        }
    }
    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div ref="dashboardcontainer" style={{ width: '100%', height: '100%' }}></div>
                {configuration.DASHBOARD.AllowEdit && <SpeedDialAction
                    icon="edit"
                    label={"Mode"}
                    index={1}
                    onClick={this.changeMode} />}
            </div>
        );
    }
}

export default DashboardComponent;